import React from 'react';
import { Routes, Route, NavLink, useNavigate } from 'react-router-dom';
import { logout } from '../../services/auth';
import AdminUsuarios from './AdminUsuarios';
import AdminCidades from './AdminCidades';
import AdminTemporadas from './AdminTemporadas';
import AdminCampeonatos from './AdminCampeonatos';
import AdminRodadas from './AdminRodadas';
import AdminTimes from './AdminTimes';
import AdminJogadores from './AdminJogadores';
import AdminJogos from './AdminJogos';
import AdminComprovantes from './AdminComprovantes';
import AdminPremiacoes from './AdminPremiacoes';
import AdminResgates from './AdminResgates';
import AdminCupons from './AdminCupons';
import AdminBanner from './AdminBanner';
import './Admin.css';

const menu = [
  { to: '/admin', label: '👥 Usuários', end: true },
  { to: '/admin/cidades', label: '🏙️ Cidades' },
  { to: '/admin/temporadas', label: '📆 Temporadas' },
  { to: '/admin/campeonatos', label: '🏆 Campeonatos' },
  { to: '/admin/rodadas', label: '🔄 Rodadas' },
  { to: '/admin/times', label: '⚽ Times' },
  { to: '/admin/jogadores', label: '🧑‍⚽ Jogadores' },
  { to: '/admin/jogos', label: '📅 Jogos' },
  { to: '/admin/comprovantes', label: '💸 Comprovantes' },
  { to: '/admin/premiacoes', label: '🎁 Premiações' },
  { to: '/admin/resgates', label: '🏅 Resgates' },
  { to: '/admin/cupons', label: '🎟️ Cupons' },
  { to: '/admin/banner', label: '🖼️ Banner da Home' },
];

export default function Admin() {
  const navigate = useNavigate();

  return (
    <div className="admin-layout">
      <aside className="admin-sidebar">
        <div className="admin-brand">⚽ Admin</div>
        <nav className="admin-nav">
          {menu.map(m => (
            <NavLink key={m.to} to={m.to} end={m.end}
              className={({ isActive }) => `admin-nav-item${isActive ? ' active' : ''}`}>
              {m.label}
            </NavLink>
          ))}
        </nav>
        <div className="admin-sidebar-footer">
          <button className="btn btn-secondary" onClick={() => navigate('/')}>← Voltar</button>
          <button className="btn btn-danger" onClick={() => { logout(); navigate('/login'); }}>Sair</button>
        </div>
      </aside>
      <main className="admin-main">
        <Routes>
          <Route index element={<AdminUsuarios />} />
          <Route path="cidades" element={<AdminCidades />} />
          <Route path="temporadas" element={<AdminTemporadas />} />
          <Route path="campeonatos" element={<AdminCampeonatos />} />
          <Route path="rodadas" element={<AdminRodadas />} />
          <Route path="times" element={<AdminTimes />} />
          <Route path="jogadores" element={<AdminJogadores />} />
          <Route path="jogos" element={<AdminJogos />} />
          <Route path="comprovantes" element={<AdminComprovantes />} />
          <Route path="premiacoes" element={<AdminPremiacoes />} />
          <Route path="resgates" element={<AdminResgates />} />
          <Route path="cupons" element={<AdminCupons />} />
          <Route path="banner" element={<AdminBanner />} />
        </Routes>
      </main>
    </div>
  );
}
